export default __webpack_public_path__ + "static/media/resume.93bebde9.pdf";